var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClosedDataRequests(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.87891 15.0148L7.07141 15.9073C8.12891 16.7023 9.86891 16.7023 10.9264 15.9073L14.1514 13.4998C14.8639 12.9673 15.4489 11.8048 15.4489 10.9198V5.33984",
    stroke: "#00B894",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2361 3.25492C14.1236 3.18742 14.0036 3.12742 13.8836 3.07492L10.1411 1.67242C9.51859 1.43992 8.49859 1.43992 7.87609 1.67242L4.12609 3.08242C3.26359 3.40492 2.55859 4.42492 2.55859 5.33992V10.9124C2.55859 11.7974 3.14359 12.9599 3.85609 13.4924L4.00609 13.6049",
    stroke: "#00B894",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 1.5L1.5 16.5",
    stroke: "#00B894",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosedDataRequests);
export default __webpack_public_path__ + "static/media/closed-data-requests.1d721a079338e89cd58ef73e6be842f0.svg";
export { ForwardRef as ReactComponent };